module.exports = __webpack_public_path__ + "static/media/QBO-offline.7aa89fa3.png";